import { api } from "@/lib/apiClient";

export type TemplateHoliday = {
  id: string;
  name: string;
  monthDay: string;
};

type ApiRow = { id?: number; name?: string; month_day?: string };

export async function fetchTemplateHolidays(): Promise<TemplateHoliday[]> {
  const res = await api.get<{ data?: ApiRow[] }>("/api/v1/template-holidays");
  const data = res.data?.data;
  if (!Array.isArray(data)) return [];
  return data
    .filter((r) => r.id != null)
    .map((r) => ({
      id: String(r.id),
      name: String(r.name ?? ""),
      monthDay: String(r.month_day ?? ""),
    }));
}
